export default function(instance){
    return{
        Convert(payload){
            return instance.get('/convert?from=' + payload.from + '&to=' + payload.to);
        },
    }
}
